export default {
  '0': {
    name: 'Iron'
  },
  '1': {
    name: 'Storm'
  },
  '2': {
    name: 'Sea'
  },
}
